// Runtime config. Override API_BASE via <meta name="api-base" content="..."> if needed.
function meta(name: string): string | null {
  return document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)?.content ?? null;
}

export const API_BASE = meta("api-base") ?? "http://localhost:8787";
export const PRODUCT = "ShortDrama";

// Current Terms/Consent policy version (mirrors KV current value, 01 §1.4 / §7.6).
export const POLICY_VERSION = meta("policy-version") ?? "2026-06-14";

// Web OAuth (Authorization Code + PKCE, 01 §4.3 / 04-web §2.2).
// These are public client identifiers; override via <meta> tags in index.html.
// Empty client id => the flow shows a clear "not configured" message instead of redirecting.
export interface OAuthProviderConfig {
  clientId: string;
  authorizeUrl: string;
  scope: string;
}

export const OAUTH: Record<string, OAuthProviderConfig> = {
  google: {
    clientId: meta("google-client-id") ?? "",
    authorizeUrl: "https://accounts.google.com/o/oauth2/v2/auth",
    scope: "openid email profile",
  },
  apple: {
    clientId: meta("apple-client-id") ?? "",
    authorizeUrl: "https://appleid.apple.com/auth/authorize",
    scope: "name email",
  },
};

// Redirect URI registered with each provider; must match the app's /auth/callback route.
export const OAUTH_REDIRECT_URI = meta("oauth-redirect-uri") ?? `${location.origin}/auth/callback`;
